export default {"src":"/_next/static/media/error_icon.0351e56d.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};